import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { DataAPi, Valuasi, EndPoint} from "../variable/dataVariable";
import { Temporal } from '@js-temporal/polyfill';
import VaService from "../../services/virtualAkun.service";

function GenerateVA() {
    const nowTime = Temporal.Now.zonedDateTimeISO().toString({ timeZoneName: 'never' });
        const [data, setData] = useState({});
        const {nama, nim, prodi, fakultas, email, tlp, billCode, billName, billAmountValue, billDescription, expiredDate, tahunAkademik, secret} = useParams()

        const body = {
            "partnerServiceId":"90168",
            "customerNo":"12345678901234567890",
            "virtualAccountNo":"  08889912345678901234567890",
            "virtualAccountName":nama,
            "virtualAccountEmail":email,
            "virtualAccountPhone":tlp,
            "trxId":"abcdefgh1234",
            "totalAmount":{
                "value":billAmountValue + ".00",
                "currency":"IDR"
            },
            "billDetails":[
                {
                    "billCode":billCode,
                    "billNo":"123456789012345678",
                    "billName":billName,
                    "billShortName":"Bill A",
                    "billDescription":{
                        "english":"Maintenance",
                        "indonesia":billDescription
                    },
                    "billSubCompany":"00001",
                    "billAmount":{
                        "value":billAmountValue + ".00",
                        "currency":"IDR"
                    },
                    "additionalInfo":{
        
                    }
                }
            ],
            "freeTexts":[
                {
                    "english":"Free text",
                    "indonesia":"Tulisan bebas"
                }
            ],
            "virtualAccountTrxType":"C",
            "feeAmount":{
                "value":"12345678.00",
                "currency":"IDR"
            },
            "expiredDate":"2020-12-31T23:59:59+07:00",
            "additionalInfo":{
                "deviceId":"12345679237",
                "channel":"mobilephone",
                "nama": "Jokul Doe",
                "nim": "12345",
                "prodi": "Hukum",
                "fakultas": "Hukum"
            }
        }
        
        useEffect(() => {
        
                const createVA = async() => {
                    await VaService.signatureAuth(nowTime)
                    .then(res => {
                        console.log(res);
                        VaService.accessToken(nowTime, res.signature)
                        .then(res => {
                            console.log(res);
                            VaService.signatureService(res.accessToken, nowTime, EndPoint.createVA, body, "POST")
                            .then(res => {
                                console.log(res);
                                VaService.servicesVA(nowTime, EndPoint.createVA, res.signature, body)
                                .then(res => {
                                    console.log(res.data);
                                    
                                    //setData(res.data)
                                })
                                .catch(err => {
                                    return updateVA();
                                })
                            })
                            .catch(err => console.log(err))
                        })
                        .catch(err => console.log(err))
                    })
                    .catch(err => console.log(err));
                }

                const updateVA = async() => {
                    await VaService.signatureAuth(nowTime)
                    .then(res => {
                        VaService.accessToken(nowTime, res.signature)
                        .then(res => {
                            VaService.signatureService(res.accessToken, nowTime, EndPoint.updateVA, body, "PUT")
                            .then(res => {
                                VaService.servicesVA(nowTime, EndPoint.updateVA, res.signature, body)
                                .then(res => {
                                    console.log(res.data);
                                    
                                    //setData(res.data)
                                })
                                .catch(err => {
                                })
                            })
                            .catch(err => console.log(err))
                        })
                        .catch(err => console.log(err))
                    })
                    .catch(err => console.log(err));
                }
                createVA();
            },[]);

        
    return(
        <>
        <div className="container bg-light my-4">
            <div className="row  g-3">
                <div className="col-md-12 text-center">
                    <h5 className="my-4">Kop Surat</h5>
                    <br></br>
                    <h6 className="my-4">Lembar Informasi Pembayaran Siakad UNISKI</h6>
                    <h6 className="my-4">Tahun Akademik {tahunAkademik}</h6>
                </div>
                <div className="col-md-12">
                    <h6>NAMA MAHASISWA</h6>
                    <h3 className="fw-bold">{data.additionalInfo} - {data.additionalInfo}</h3>
                </div>
                <div className="col-md-6">
                        <table className="table border border-black text-start" style={{width: "100%"}}>
                            <tr>
                                <td><h6>NOMOR VIRTUAL ACCOUNT</h6></td>
                                <td style={{width: "10px"}}>:</td>
                                <td className="fw-bold">{data.virtualAccountNo}</td>
                            </tr>
                            <tr>
                                <td><h6>BATAS AKHIR PEMBAYARAN</h6></td>
                                <td style={{width: "10px"}}>:</td>
                                <td>{data.expiredDate}</td>
                            </tr>                      
                        </table>
                </div>
                
                
                <div className="col-md-12 row g-1">
                    <div className="col-md-6">
                        <table className="table border border-black" style={{width: "100%"}}>
                            <tr>
                                <td><h6>Pembayran Dapat Dilakukan Melalui</h6></td>
                            </tr>
                            <tr>
                                <td><h6>Bank Mitra</h6></td>
                                <td style={{width: "10px"}}>:</td>
                                <td>BPD Sumatera Selatan dan Bangka Belitung</td>
                            </tr>
                            <tr>
                                <td><h6>Online/Mobile Banking</h6></td>
                                <td style={{width: "10px"}}>:</td>
                                <td>Mobile Banking Seluruh Bank di Indonesia</td>
                            </tr>                       
                        </table>
                    </div>
                    <div className="col-md-6 row g-1">
                        <div className="col-md-6">
                            <table className="table" style={{width: "100%"}}>
                            <tr>
                                <td><h6 className="fw-bold">Detail Tagihan</h6></td>
                            </tr>
                            <tr>
                                <td><h6>kode Kegiatan</h6></td>
                                <td style={{width: "10px"}}>:</td>
                                <td className="fw-bold">{data.billCode}</td>
                            </tr>
                            <tr>
                                <td><h6>Nama Kegiatan</h6></td>
                                <td style={{width: "10px"}}>:</td>
                                <td className="fw-bold">{data.billName}</td>
                            </tr>                       
                        </table>
                        </div>
                        <div className="col-md-6">
                            <table className="table" style={{width: "100%"}}>
                            <tr>
                                <td><h6 className="fw-bold">Jumlah Tagihan</h6></td>
                            </tr>
                            <tr>
                                <td><h6>Rp.</h6></td>
                                <td className="fw-bold">{data.billAmountValue}</td>
                            </tr>               
                        </table>
                        </div>
                    </div>
                    
                </div>
                
                <div className="col-md-6 text-center">
                    <br></br>
                    <br></br>
                    <h6>Mahasiswa</h6>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <h6 className="border-bottom border-black m-auto" style={{width: "200px"}}></h6>
                </div>
                <div className="col-md-6 text-center">
                    <br></br>
                    <br></br>
                    <h6>Petugas Bank</h6>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <h6 className="border-bottom border-black m-auto" style={{width: "200px"}}></h6>
                </div>
                <div className="col-md-6">
                    <Link to="/virtual-akun" className="btn btn-primary">Print</Link>
                </div>
                <div className="col-md-6">
                </div>
            </div>
        </div>
        </>
    )
}

export default GenerateVA;